/**
 * The Dometry logotype, drawn rather than typeset so every letter shares the
 * mark's line: a 2.8 stroke with round ends on a 32-unit-high grid, capitals
 * from y=7 to y=25. The first 32 units are the mark itself (the D with its
 * inner arch), so the full logotype narrows to the mark by clipping.
 */
export const LOGO_HEIGHT = 32;
export const MARK = {
  d: 'M9 7v18M9 7h4a9 9 0 0 1 0 18h-4',
  arch: 'M13 12a4 4 0 0 1 0 8',
};

/** Letter widths (units) and outlines, drawn from their left edge `x`. */
const LETTERS: Record<string, { width: number; path: (x: number) => string }> = {
  O: { width: 18, path: (x) => `M${x + 9} 7a9 9 0 1 1 0 18a9 9 0 1 1 0-18` },
  M: { width: 15, path: (x) => `M${x} 25V7l7.5 11L${x + 15} 7v18` },
  E: { width: 10, path: (x) => `M${x + 10} 7H${x}v18h10M${x} 16h8` },
  T: { width: 12, path: (x) => `M${x} 7h12M${x + 6} 7v18` },
  R: { width: 11, path: (x) => `M${x} 25V7h6a5 5 0 0 1 0 10H${x}m6 0l5 8` },
  Y: { width: 12, path: (x) => `M${x} 7l6 9l6-9M${x + 6} 16v9` },
};

const D_RIGHT = 22; // where the mark's D ends
const TRACKING = 11.7; // space between letters: generous, as in the old set wordmark
const SIDE = 9; // the mark's own left margin, repeated on the right

function layout(): { path: string; width: number } {
  let x = D_RIGHT + TRACKING;
  const parts: string[] = [];
  for (const ch of 'OMETRY') {
    const letter = LETTERS[ch];
    if (!letter) continue;
    parts.push(letter.path(x));
    x += letter.width + TRACKING;
  }
  return { path: parts.join(''), width: x - TRACKING + SIDE };
}

/** "OMETRY", to follow the mark, and the full logotype's width in units. */
export const WORDMARK = layout();
